<template>
  <div class="feedback">
    <div class="content">
      <div>
        <p class="title">请对简历做出评价</p>
      </div>
      <el-row>
        <el-col :span="24" class="info">
          <el-col :span="12"> 个人信息 </el-col>
        </el-col>
        <el-col :span="8" class="item spec">
          <el-col :span="24"> 姓名 </el-col>
          <el-col :span="24">
            {{ personInfo.nickName }}
          </el-col>
        </el-col>
        <el-col :span="8" class="item spec">
          <el-col :span="24"> 性别 </el-col>
          <el-col :span="24">
            {{ personInfo.sex }}
          </el-col>
        </el-col>
        <el-col :span="8" class="item spec">
          <el-col :span="24"> 籍贯 </el-col>
          <el-col :span="24">
            {{ personInfo.nativePlace }}
          </el-col>
        </el-col>
        <el-col :span="8" class="item spec">
          <el-col :span="24"> 手机号 </el-col>
          <el-col :span="24"> {{ personInfo.phoneNumber }} </el-col>
        </el-col>
        <el-col :span="8" class="item spec">
          <el-col :span="24"> 邮箱 </el-col>
          <el-col :span="24"> {{ personInfo.email }} </el-col>
        </el-col>
        <el-col :span="8" class="item">
          <el-col :span="24"> 学习成绩排名 </el-col>
          <el-col :span="24"> {{ personInfo.scoreRanking }} </el-col>
        </el-col>
        <el-col :span="8" class="item">
          <el-col :span="24"> 英语水平 </el-col>
          <el-col :span="24"> {{ personInfo.englishLevel }} </el-col>
        </el-col>
        <el-col :span="8" class="item">
          <el-col :span="24"> 学校名称 </el-col>
          <el-col :span="24"> {{ personInfo.school }} </el-col>
        </el-col>
        <el-col :span="8" class="item">
          <el-col :span="24"> 学历 </el-col>
          <el-col :span="24"> {{ personInfo.education }} </el-col>
        </el-col>
        <el-col :span="8" class="item">
          <el-col :span="24"> 学习类型 </el-col>
          <el-col :span="24"> {{ personInfo.learnType }} </el-col>
        </el-col>
        <el-col :span="8" class="item">
          <el-col :span="24"> 学习类别 </el-col>
          <el-col :span="24"> {{ personInfo.schoolCategory }} </el-col>
        </el-col>
        <el-col :span="8" class="item">
          <el-col :span="24"> 专业名称 </el-col>
          <el-col :span="24"> {{ personInfo.majorName }} </el-col>
        </el-col>
        <el-col :span="8" class="item">
          <el-col :span="24"> 是否挂科 </el-col>
          <el-col :span="24" v-show="(personInfo.ifFail != null)"> {{ personInfo.ifFail == 1? "是":"否" }} </el-col>
        </el-col>
        <el-col :span="8" class="item">
          <el-col :span="24"> 是否服从调剂 </el-col>
          <el-col :span="24" v-show="(personInfo.ifObeyAdjust != null)"> {{ personInfo.ifObeyAdjust == 1? "是":"否" }} </el-col>
        </el-col>
        <el-col :span="8" class="item">
          <el-col :span="24"> 基础得分 </el-col>
          <el-col :span="24"> {{personInfo.gradeScore}} </el-col>
        </el-col>
        <el-col :span="8" class="item">
          <el-col :span="24"> 电子简历 </el-col>
          <el-col :span="24" class="resume" v-show="(personInfo.attachment != null)">
            <img alt="" src="@/assets/image/resume.png"  @click="showResume(personInfo.attachment)"/>
            (~戳我戳我~)
          </el-col>
        </el-col>
        <el-col :span="24" class="info">
          <el-col :span="12"> 评分 </el-col>
        </el-col>
      </el-row>
			<el-row class="contentEvaluate">
        <el-col :span="24" class="part">
            <el-col :span="3"> 面试要素 </el-col>
            <el-col :span="16">
              评分标准：优秀=5，良好=4,一般=3，较差=2，极差=1
            </el-col>
            <el-col :span="5">
              得分
            </el-col>
          </el-col>
          <el-col :span="24" class="part">
            <el-col :span="3"> 积极主动 </el-col>
            <el-col :span="16">
              具有积极的生活态度和工作方式，喜欢积极参与，自发行动
            </el-col>
            <el-col :span="5">
              <el-rate
                v-model="qualityPart1"
                :colors="colors"
                @change="pointChange">
              </el-rate>
            </el-col>
          </el-col>
          <el-col :span="24" class="part">
            <el-col :span="3"> 学习能力 </el-col>
            <el-col :span="16">
              愿意学习新事物，能够系统快速地掌握新知识并加以运用
            </el-col>
            <el-col :span="5">
              <el-rate
                v-model="qualityPart2"
                :colors="colors"
                @change="pointChange">
              </el-rate>
            </el-col>
          </el-col>
          <el-col :span="24" class="part">
            <el-col :span="3"> 适应转变 </el-col>
            <el-col :span="16">
              主动接受变化，保持乐观的心态，并积极调整自己以适应变化
            </el-col>
            <el-col :span="5">
              <el-rate
                v-model="qualityPart3"
                :colors="colors"
                @change="pointChange">
              </el-rate>
            </el-col>
          </el-col>
          <el-col :span="24" class="part">
            <el-col :span="3"> 抗压能力 </el-col>
            <el-col :span="16">
              正确认识压力来源并能积极进行自我调整，有效应对压力
            </el-col>
            <el-col :span="5">
              <el-rate
                v-model="qualityPart4"
                :colors="colors"
                @change="pointChange">
              </el-rate>
            </el-col>
          </el-col>
          <el-col :span="24" class="part">
            <el-col :span="3"> 坚韧性 </el-col>
            <el-col :span="16">
              意志坚定，困难面前信念坚定，并积极进行自我激励
            </el-col>
            <el-col :span="5">
              <el-rate
                v-model="qualityPart5"
                :colors="colors"
                @change="pointChange">
              </el-rate>
            </el-col>
          </el-col>
          <el-col :span="24" class="part">
            <el-col :span="3"> 沟通能力 </el-col>
            <el-col :span="16">
              有主动沟通的意愿，清晰表达自己的观点，认真倾听他人的想法
            </el-col>
            <el-col :span="5">
              <el-rate
                v-model="qualityPart6"
                :colors="colors"
                @change="pointChange">
              </el-rate>
            </el-col>
          </el-col>
          <el-col :span="24" class="part">
            <el-col :span="3"> 团队合作 </el-col>
            <el-col :span="16">
              信任他人，以团队为重，注重合作
            </el-col>
            <el-col :span="5">
              <el-rate
                v-model="qualityPart7"
                :colors="colors"
                @change="pointChange">
              </el-rate>
            </el-col>
          </el-col>
          <el-col :span="24" class="part">
            <el-col :span="3"> 认真负责 </el-col>
            <el-col :span="16">
              正确认知工作职责，能够保质保量地完成工作，主动承担工作责任
            </el-col>
            <el-col :span="5">
              <el-rate
                v-model="qualityPart8"
                :colors="colors"
                @change="pointChange">
              </el-rate>
            </el-col>
          </el-col>
          <el-col :span="24" class="part">
            <el-col :span="3"> 严谨细致 </el-col>
            <el-col :span="16">
              持续关注影响工作的关键细节，考虑周全，行事严谨，追求精确
            </el-col>
            <el-col :span="5">
              <el-rate
                v-model="qualityPart9"
                :colors="colors"
                @change="pointChange">
              </el-rate>
            </el-col>
          </el-col>
          <el-col :span="24" class="part">
            <el-col :span="3"> 高效执行 </el-col>
            <el-col :span="16">
              快速响应组织政策或指令，并能够在较短时间内高效落实
            </el-col>
            <el-col :span="5">
              <el-rate
                v-model="qualityPart10"
                :colors="colors"
                @change="pointChange">
              </el-rate>
            </el-col>
          </el-col>
          <el-col :span="24" class="additional">
            <el-col :span="8"> 
              <el-col :span="24"> 
                <el-col :span="8" class="addItem">
                  有无加分项：
                </el-col>
                <el-col :span="15">
                  <el-select
                    v-model="additional"
                    placeholder="请选择"
                    size="medium"
                  >
                    <el-option
                      v-for="(item, index) in decideList"
                      :key="index"
                      :label="item.name"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-col>
              </el-col>
              <el-col :span="24" style="color: #722ed1;font-size: 12px;margin-top: 5px;"> 
                (不超过15分)
              </el-col>
            </el-col>
            <el-col :span="8" v-show="additional">
              <el-col :span="6" class="addItem" align="right">
                加分项：
              </el-col>
              <el-col :span="18">
                <el-input v-model="explain" type="textarea" :rows="4" :placeholder="placeholder"></el-input>
              </el-col>
            </el-col>
            <el-col :span="8" v-show="additional">
              <el-col :span="6" class="addItem" align="right">
                分值：
              </el-col>
              <el-col :span="18">
                <el-input-number controls-position="right" size="medium" v-model="score" @change="pointChange" :min="0" :max="15" label="分值"></el-input-number>
              </el-col>
            </el-col>
          </el-col>
          <el-col :span="24" align="right" class="totalNum">
            合计得分(基础+素质+加分)：{{totalNum}}
          </el-col>
          <el-col :span="24" align="right" class="submitBtn">
            <el-button type="primary" v-waves size="medium" class="submitButton" @click="submit">提交</el-button>
          </el-col>
          <el-col :span="24" class="tips">
            <i class="el-icon-question"></i> 总分：60分以下不建议录用，60-74分为一般，75-89分为良好，90（含）以上为优秀
          </el-col>
        </el-row>
    </div>
		
  </div>
</template>
    
<script>
import {Base64} from 'js-base64';
import Headers from "@/components/Headers.vue";
import Footer from "@/components/Footer.vue";
import waves from "@/directive/waves";

export default {
  name: "feedback",
  components: { Headers, Footer },
  directives: {
    waves,
  },
  data() {
    return {
      qualityPart1: null,
      qualityPart2: null,
      qualityPart3: null,
      qualityPart4: null,
      qualityPart5: null,
      qualityPart6: null,
      qualityPart7: null,
      qualityPart8: null,
      qualityPart9: null,
      qualityPart10: null,
      totalNum: 0, //总分
      colors: ['#99A9BF', '#F7BA2A', '#FF9900'],
      personInfo: {},
      resumeId: 0,
      explain: "", //说明
      evaluateContent: "",
      placeholder:"填写具体的加分说明（比方说竞赛奖项等）",
      additional: 0,
      decideList: [
        {
          value: 1,
          name: "有",
        },
        {
          value: 0,
          name: "无",
        },
      ], // 选择 列表
      score: 0,
      taskStatus:0,// 简历状态
    };
  },
  created() {
    this.resumeId = Base64.decode(this.$route.query.JXU3QjgwJXU1Mzg2);
    if(isNaN(this.resumeId)){
      this.$message.error("查询错误请重试！");
    }else{
      this.getInfo(this.resumeId);
    }
  },
  methods: {
    pointChange(){
      if(isNaN(this.score)){
        this.score = 0;
      }
      let count = this.personInfo.gradeScore;
      this.totalNum = count + this.qualityPart1 + this.qualityPart2 + this.qualityPart3 + this.qualityPart4 + this.qualityPart5 + this.qualityPart6 + this.qualityPart7 + this.qualityPart8
      + this.qualityPart9 + this.qualityPart10 + this.score;
    },
		showResume(url){
			this.$preview({
        url: "http://openapi.qtechglobal.com:8003/QHR/" + url,
				fid: '12121212'
			})
		},
    getInfo(id) {
      this.axios({
        url: "/apis/resume/info/" + id,
        method: "get",
      }).then((res) => {
        if (res.code == 200) {
          let data = res.data;
          this.taskStatus = data.taskStatus;
          this.personInfo = data;
          this.qualityPart1 = data.qualityScore1;
          this.qualityPart2 = data.qualityScore2;
          this.qualityPart3 = data.qualityScore3;
          this.qualityPart4 = data.qualityScore4;
          this.qualityPart5 = data.qualityScore5;
          this.qualityPart6 = data.qualityScore6;
          this.qualityPart7 = data.qualityScore7;
          this.qualityPart8 = data.qualityScore8;
          this.qualityPart9 = data.qualityScore9;
          this.qualityPart10 = data.qualityScore10;
					this.explain = data.bonusContent;
          if(!this.explain){
            this.additional = 0;
          }else{
            this.additional = 1;
          }
					this.score = data.bonus;
          this.totalNum = data.gradeScore + data.qualityScore1 + data.qualityScore2 + data.qualityScore3 + data.qualityScore4 + data.qualityScore5 + data.qualityScore6 + data.qualityScore7
          + data.qualityScore8 + data.qualityScore9 + data.qualityScore10 + data.bonus;
        } else {
          this.personInfo = {};
        }
      });
    },
		submit(){
      if(this.taskStatus == 0){
        this.$message.error("该简历暂未分派！");
        return false;
      }
      if(!this.qualityPart1){
        this.$message.warning("积极主动评分不可为空！");
        return false;
      }
      if(!this.qualityPart2){
        this.$message.warning("学习能力评分不可为空！");
        return false;
      }
      if(!this.qualityPart3){
        this.$message.warning("适应转变评分不可为空！");
        return false;
      }
      if(!this.qualityPart4){
        this.$message.warning("抗压能力评分不可为空！");
        return false;
      }
      if(!this.qualityPart5){
        this.$message.warning("坚韧性评分不可为空！");
        return false;
      }
      if(!this.qualityPart6){
        this.$message.warning("沟通能力评分不可为空！");
        return false;
      }
      if(!this.qualityPart7){
        this.$message.warning("团队合作评分不可为空！");
        return false;
      }
      if(!this.qualityPart8){
        this.$message.warning("认真负责评分不可为空！");
        return false;
      }
      if(!this.qualityPart9){
        this.$message.warning("严谨细致评分不可为空！");
        return false;
      }
      if(!this.qualityPart10){
        this.$message.warning("高效执行评分不可为空！");
        return false;
      }
      if(isNaN(this.score)){
        this.score = 0;
      }
      if(this.additional){
        if(!this.explain){
          this.$message.warning("请输入加分项说明！");
          return false;
        }
        if(!this.score){
          this.$message.warning("请输入加分！");
          return false;
        }
      }else{
        this.explain = "";
        this.score = "";
      }
			let params = {
				resumeId: this.resumeId,
				basicScore: this.personInfo.gradeScore,
        qualityScore1: this.qualityPart1,
        qualityScore2: this.qualityPart2,
        qualityScore3: this.qualityPart3,
        qualityScore4: this.qualityPart4,
        qualityScore5: this.qualityPart5,
        qualityScore6: this.qualityPart6,
        qualityScore7: this.qualityPart7,
        qualityScore8: this.qualityPart8,
        qualityScore9: this.qualityPart9,
        qualityScore10: this.qualityPart10,
				bonus: this.score,
        bonusContent: this.explain
			}
			this.axios({
        url: "/apis/resume/score",
        method: "post",
				data: params
      }).then((res) => {
        if (res.code == 200) {
          this.$message.success("评价成功！");
        } else {
          this.$message.error("评价失败，请重试！");
        }
      });
		}
  },
};
</script>
    
<style lang="scss" scoped>
.feedback {
  text-align: left;
  padding: 20px 0;
  .content {
    width: 900px;
    margin: 0 auto;
    border: 5px solid #722ed1;
    border-top: none;
    border-radius: 10px;
    padding: 20px;
    overflow: hidden;
    .info {
      font-size: 20px;
      padding-bottom: 2px;
      border-bottom: 1px solid #ccc;
      margin: 20px 0 10px;
      color: #722ed1;
      font-weight: bold;
    }
    .avatar {
      padding-top: 5px;
      > div {
        width: 125px;
        height: 125px;
        position: relative;
        background-color: #000;
        overflow: hidden;
        img {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        }
      }
    }
    .ant-select {
      width: 100% !important;
      .ant-select-selector {
        width: 100%;
      }
    }
    .contentEvaluate{
      .part{
        font-size: 15px;
        &:nth-child(1){
          background-color: #ccc;
          color: #722ed1;
          font-weight: bold;
          >div{
            border: none;
            line-height: 42px;
            height: 42px;
          }
        }
        >div{
          line-height: 38px;
          height: 38px;
          text-align: left;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          border-bottom: 1.5px dashed #722ed1;
          padding-left: 10px;
          .el-rate{
            display: flex;
          }
        }
      }
      .additional{
        margin-top: 20px;
        .addItem{
          font-size: 14px;
          height: 36px;
          line-height: 36px;
          color: #722ed1;
        }
        >div{
          padding: 0 10px;
          span{
            color: #722ed1;
            line-height: 30px;
          }
        }
      }
      .totalNum{
        font-size: 20px;
        color: #722ed1;
        font-weight: bold;
        margin-top: 20px;
      }
      .submitBtn{
        margin-top: 10px;
      }
      .tips{
        margin-top: 20px;
        color: #722ed1;
        font-weight: bold;
        i{
          font-size: 30px;
          vertical-align: middle;
          margin-top: -3px;
        }
      }
    }
    .evaluate {
      width: 50%;
      margin-bottom: 5px;
      line-height: 25px;
      vertical-align: middle;
      font-size: 15px;

      > div {
        &:nth-child(1) {
          font-weight: bold;
        }
        &:nth-child(2) {
          font-size: 14px;
          > div {
            width: 100% !important;
          }
          button {
            float: right;
            margin-top: 30px;
          }
        }
      }
      &:nth-child(1) {
        float: left;
      }
      &:nth-child(2) {
        float: right;
      }
    }
    .title {
      padding: 10px 20px 0;
      height: 80px;
      color: #d1d1d1;
      font-size: 26px;
      color: #fff;
      margin: -20px -20px 20px -30px;
      background-color: #722ed1;
    }
    .resume {
      img {
        cursor: pointer;
        width: 25px;
        display: inline-block;
        vertical-align: middle;
      }
    }
    .item {
      margin-bottom: 5px;
      line-height: 25px;
      height: 50px;
      vertical-align: middle;
      font-size: 15px;
  		overflow: hidden;
			text-overflow:ellipsis;
			white-space: nowrap;
      color: #000;
      &.spec{
        color: #722ed1;
        font-size: 16px;
      }
      > div {
        &:nth-child(1) {
          font-weight: bold;
        }
        &:nth-child(2) {
          font-size: 14px;
        }
      }
    }
  }
	.submitButton{
		color: #fff;
		background-color: #722ed1;
		border: none;
	}
}
</style>
<style lang="scss">
.feedback {
	.el-textarea__inner{
		border: 1px solid #722ed1;
	}
  .el-select{
    width: 100%;
    padding-left: 0 !important;
  }
	.el-input__inner{
		border: 1px solid #722ed1;
	}
	.el-input-number{
		width: 100%;
	}
  .el-select .el-input.is-focus .el-input__inner{
		border-color: #722ed1;
  }
  .el-select .el-input__inner:focus{
		border-color: #722ed1;
  }
	.el-input-number__increase:hover:not(.is-disabled) ~ .el-input .el-input__inner:not(.is-disabled), .el-input-number__decrease:hover:not(.is-disabled) ~ .el-input .el-input__inner:not(.is-disabled){
		border-color: #722ed1;
	}
	.el-input-number__decrease{
		color: #722ed1;
	}
	.el-input-number__increase{
		color: #722ed1;
	}
  .el-select-dropdown__item.selected{
    color: #722ed1 !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/onlineApp/feedback.vue